module.exports = __webpack_public_path__ + "static/media/summer-night.380893a6.mp3";